import { supabase } from '@/lib/supabase-client'
import { logger } from '@/logger'

export type EnsureStripeCustomerResult = {
  customer_id: string
}

export async function ensureStripeCustomer(): Promise<EnsureStripeCustomerResult> {
  const { data: session } = await supabase.auth.getSession()

  if (!session.session) {
    throw new Error('Not authenticated')
  }

  const functionUrl = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/ensure-stripe-customer`

  const response = await fetch(functionUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.session.access_token}`,
    },
  })

  if (!response.ok) {
    const error = await response.json()
    logger.error('Failed to ensure Stripe customer', { error })
    throw new Error(error.error || 'Failed to ensure Stripe customer')
  }

  const data = await response.json()
  return data
}
